// DISCIPLAY — Build Your Kit configurator v6
// Single-step accordion, auto-advance, compact sticky bar.
// Set tier comes from ?set= URL param (chosen on landing page).

(function () {
  'use strict';

  var KIT_KEY = 'disciplay_kit_v3';
  var REF_KEY = 'disciplay_ref';

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    function thousands(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function fmt(precision) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var out = thousands(parts[0]);
      return parts[1] ? out + '.' + parts[1] : out;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return key.indexOf('no_decimals') !== -1 ? fmt(0) : fmt(2);
    });
  }

  function readJSON(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); }
    catch (e) { return null; }
  }

  function activeReferrer() {
    var stored = readJSON(REF_KEY);
    if (stored && stored.ref && (!stored.expiry || stored.expiry > Date.now())) return stored.ref;
    return null;
  }

  function initKitBuilder(root) {
    if (!root || root.__kitInit) return;
    var configEl = root.querySelector('[data-kit-config]');
    if (!configEl) return;
    root.__kitInit = true;

    var cfg;
    try { cfg = JSON.parse(configEl.textContent); }
    catch (e) { return; }

    var pickN = cfg.picksPerGroup || 3;
    var machines = cfg.machines || [];
    var sets = cfg.sets || [];
    var variants = cfg.variants || [];
    var groupLabels = cfg.groupLabels || { a: 'Functional', b: 'Toys', c: 'Apparel' };
    var lightbox = document.querySelector('[data-kit-lightbox]');
    var breakdown = root.querySelector('[data-kit-breakdown]');

    // accessory cards keyed by handle
    var cards = {};
    root.querySelectorAll('[data-kit-card]').forEach(function (card) {
      cards[card.dataset.handle] = card;
    });

    var state = {
      machine: machines.length ? machines[0].value : 'Entry',
      set: sets.length ? sets[0].value : 'Set 1',
      picks: { a: [], b: [], c: [] }
    };

    // ── definitions / helpers ─────────────────────────
    function setDef(value) {
      for (var i = 0; i < sets.length; i++) if (sets[i].value === value) return sets[i];
      return sets[0] || { value: 'Set 1', label: 'Starter', groups: ['a'] };
    }
    function machineDef(value) {
      for (var i = 0; i < machines.length; i++) if (machines[i].value === value) return machines[i];
      return machines[0] || { value: 'Entry', handle: '', label: 'Entry' };
    }
    function activeGroups() { return setDef(state.set).groups; }
    function isGroupActive(cat) { return activeGroups().indexOf(cat) !== -1; }

    function premiumCount() {
      var n = 0;
      activeGroups().forEach(function (cat) {
        state.picks[cat].forEach(function (h) {
          var c = cards[h];
          if (c && c.dataset.premium === 'true') n++;
        });
      });
      return n;
    }

    function variantFor(machine, set, premium) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.machine === machine && v.set === set && String(v.premium) === String(premium)) return v;
      }
      // fallback: closest valid
      var best = null;
      variants.forEach(function (v) {
        if (v.machine === machine && v.set === set) {
          var p = parseInt(v.premium, 10) || 0;
          if (p <= premium && (!best || p > parseInt(best.premium, 10))) best = v;
        }
      });
      return best;
    }

    // ── persistence ───────────────────────────────────
    function save() {
      try { localStorage.setItem(KIT_KEY, JSON.stringify({ machine: state.machine, set: state.set, picks: state.picks })); }
      catch (e) { /* no-op */ }
    }

    // ── card visual + select ──────────────────────────
    function cardSelected(card, on) {
      card.classList.toggle('is-selected', on);
      var btn = card.querySelector('[data-kit-select]');
      if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function applyCardLocks() {
      ['a', 'b', 'c'].forEach(function (cat) {
        var full = state.picks[cat].length >= pickN;
        root.querySelectorAll('[data-kit-card][data-category="' + cat + '"]').forEach(function (card) {
          if (card.dataset.available !== 'true') return;
          var selected = state.picks[cat].indexOf(card.dataset.handle) !== -1;
          var lock = full && !selected;
          card.classList.toggle('is-locked', lock);
          var btn = card.querySelector('[data-kit-select]');
          if (btn) btn.disabled = lock;
        });
      });
    }

    function togglePick(handle) {
      var card = cards[handle];
      if (!card || card.dataset.available !== 'true') return;
      var cat = card.dataset.category;
      if (!isGroupActive(cat)) return;
      var idx = state.picks[cat].indexOf(handle);
      if (idx !== -1) {
        state.picks[cat].splice(idx, 1);
        cardSelected(card, false);
      } else {
        if (state.picks[cat].length >= pickN) return;
        state.picks[cat].push(handle);
        cardSelected(card, true);
        if (state.picks[cat].length === pickN) {
          var groups = activeGroups();
          var pos = groups.indexOf(cat);
          for (var i = pos + 1; i < groups.length; i++) {
            if (state.picks[groups[i]].length < pickN) {
              openOnly(groups[i]);
              scrollToStep(groups[i]);
              break;
            }
          }
        }
      }
      applyCardLocks();
      render();
      save();
      syncLightboxButton();
    }

    // ── accordion ─────────────────────────────────────
    function stepEl(name) { return root.querySelector('[data-kit-step="' + name + '"]'); }

    function openOnly(name) {
      root.querySelectorAll('[data-kit-step]').forEach(function (s) {
        var on = s.dataset.kitStep === name && !s.hasAttribute('hidden');
        s.classList.toggle('is-open', on);
        var head = s.querySelector('[data-kit-step-toggle]');
        if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    function scrollToStep(name) {
      // Wait for the accordion grid-rows transition (.28s) to settle so the
      // collapsing step no longer skews the target's measured position.
      setTimeout(function () {
        var s = stepEl(name);
        if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    function applySetVisibility() {
      var groups = activeGroups();
      ['a', 'b', 'c'].forEach(function (cat) {
        var s = stepEl(cat);
        if (!s) return;
        if (groups.indexOf(cat) !== -1) {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
          state.picks[cat].forEach(function (h) {
            var c = cards[h];
            if (c) cardSelected(c, false);
          });
          state.picks[cat] = [];
        }
      });
    }

    // ── machine selection ─────────────────────────────
    function setMachine(value) {
      state.machine = value;
      root.querySelectorAll('[data-kit-machine-card]').forEach(function (cardEl) {
        var sel = cardEl.querySelector('[data-kit-machine-select]');
        var on = cardEl.dataset.kitMachine === value;
        cardEl.classList.toggle('is-selected', on);
        if (sel) sel.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      updateMachineDetail();
    }

    function updateMachineDetail() {
      var mediaSlot = root.querySelector('[data-kit-machine-detail-media]');
      var bodySlot = root.querySelector('[data-kit-machine-detail-body]');
      if (!mediaSlot || !bodySlot) return;
      var selected = null;
      root.querySelectorAll('[data-kit-machine-card]').forEach(function (cardEl) {
        if (cardEl.dataset.kitMachine === state.machine) selected = cardEl;
      });
      if (!selected) return;
      var tpl = selected.querySelector('[data-kit-detail]');
      if (!tpl) return;
      mediaSlot.innerHTML = '';
      bodySlot.innerHTML = '';
      var frag = tpl.content.cloneNode(true);
      var mediaEl = frag.querySelector('.kit-detail__media');
      var bodyEl = frag.querySelector('.kit-detail__body');
      if (mediaEl) mediaSlot.appendChild(mediaEl);
      if (bodyEl) bodySlot.appendChild(bodyEl);
    }

    // ── render summary, head subs, progress ───────────
    function render() {
      var prem = premiumCount();
      var v = variantFor(state.machine, state.set, prem);
      var base = variantFor(state.machine, state.set, 0);
      var totalPrice = v ? v.price : (base ? base.price : 0);

      // Set chip name (label from setDef)
      var chipName = root.querySelector('[data-kit-setchip-name]');
      if (chipName) chipName.textContent = setDef(state.set).label || state.set;

      // Step subs
      ['a', 'b', 'c'].forEach(function (cat) {
        var sub = root.querySelector('[data-kit-head-sub="' + cat + '"]');
        var s = stepEl(cat);
        if (!s) return;
        var n = state.picks[cat].length;
        if (sub) sub.textContent = n + ' / ' + pickN;
        s.classList.toggle('is-complete', n >= pickN);
      });

      // Sticky bar total
      var totalEl = root.querySelector('[data-kit-total]');
      if (totalEl) totalEl.textContent = formatMoney(totalPrice, cfg.moneyFormat);

      // Premium text on sticky bar
      var premText = root.querySelector('[data-kit-premium-text]');
      if (premText) {
        if (prem > 0 && base) {
          premText.hidden = false;
          premText.textContent = '+ ' + formatMoney(totalPrice - base.price, cfg.moneyFormat) + ' premium';
        } else {
          premText.hidden = true;
          premText.textContent = '';
        }
      }

      // Progress
      var groups = activeGroups();
      var done = 0;
      var need = groups.length * pickN;
      groups.forEach(function (cat) { done += state.picks[cat].length; });
      var pct = need > 0 ? Math.round((done / need) * 100) : 0;
      var fill = root.querySelector('[data-kit-progress-fill]');
      if (fill) fill.style.width = pct + '%';
      var ptxt = root.querySelector('[data-kit-progress-text]');
      if (ptxt) ptxt.textContent = done + ' / ' + need;

      // CTA
      var ready = done === need && need > 0;
      var cta = root.querySelector('[data-kit-cta]');
      if (cta) cta.disabled = !ready;

      // Breakdown drawer total (when open)
      var btot = root.querySelector('[data-kit-breakdown-total]');
      if (btot) btot.textContent = formatMoney(totalPrice, cfg.moneyFormat);
      fillBreakdown();
    }

    function fillBreakdown() {
      var list = root.querySelector('[data-kit-breakdown-list]');
      if (!list) return;
      var html = '';
      html += '<li class="kit-breakdown__item"><span class="kit-breakdown__item-cat">Machine</span><span>' +
              escapeHtml(machineDef(state.machine).label || state.machine) + '</span></li>';
      activeGroups().forEach(function (cat) {
        state.picks[cat].forEach(function (h) {
          var c = cards[h];
          if (!c) return;
          var isPrem = c.dataset.premium === 'true';
          html += '<li class="kit-breakdown__item">' +
                  '<span class="kit-breakdown__item-cat">' + escapeHtml(groupLabels[cat] || cat.toUpperCase()) + '</span>' +
                  '<span>' + escapeHtml(c.dataset.title || h) +
                  (isPrem ? ' <span class="kit-breakdown__item-tag">+$' + (c.dataset.upcharge || '15') + '</span>' : '') +
                  '</span></li>';
        });
      });
      list.innerHTML = html;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // ── lightbox (accessory detail) ───────────────────
    var lightboxCard = null;

    function openLightbox(card) {
      if (!lightbox) return;
      var tpl = card.querySelector('[data-kit-detail]');
      var mediaSlot = lightbox.querySelector('[data-kit-lightbox-media]');
      var contentSlot = lightbox.querySelector('[data-kit-lightbox-content]');
      if (!tpl || !mediaSlot || !contentSlot) return;
      mediaSlot.innerHTML = '';
      contentSlot.innerHTML = '';
      var frag = tpl.content.cloneNode(true);
      var mediaEl = frag.querySelector('.kit-detail__media');
      var bodyEl = frag.querySelector('.kit-detail__body');
      if (mediaEl) mediaSlot.appendChild(mediaEl);
      if (bodyEl) contentSlot.appendChild(bodyEl);
      lightboxCard = card;
      syncLightboxButton();
      lightbox.removeAttribute('hidden');
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var panel = lightbox.querySelector('.kit-lightbox__panel');
      if (panel) panel.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { lightbox.setAttribute('hidden', ''); }, 240);
      lightboxCard = null;
    }

    function syncLightboxButton() {
      if (!lightbox || !lightboxCard) return;
      var btn = lightbox.querySelector('[data-kit-lightbox-add]');
      if (!btn) return;
      var handle = lightboxCard.dataset.handle;
      var cat = lightboxCard.dataset.category;
      var selected = state.picks[cat].indexOf(handle) !== -1;
      var full = state.picks[cat].length >= pickN;
      var active = isGroupActive(cat);
      btn.classList.toggle('is-remove', selected);
      if (lightboxCard.dataset.available !== 'true') {
        btn.disabled = true; btn.textContent = 'Sold out';
      } else if (!active) {
        btn.disabled = true; btn.textContent = 'Unlock with a higher Set';
      } else if (selected) {
        btn.disabled = false; btn.textContent = 'Remove from kit';
      } else if (full) {
        btn.disabled = true; btn.textContent = 'Group full — swap one out';
      } else {
        btn.disabled = false; btn.textContent = 'Add to my kit';
      }
    }

    // ── breakdown drawer ──────────────────────────────
    function openBreakdown() {
      if (!breakdown) return;
      breakdown.removeAttribute('hidden');
      requestAnimationFrame(function () { breakdown.classList.add('is-open'); });
      var pb = root.querySelector('[data-kit-summary-expand]');
      if (pb) pb.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeBreakdown() {
      if (!breakdown) return;
      breakdown.classList.remove('is-open');
      setTimeout(function () { breakdown.setAttribute('hidden', ''); }, 240);
      var pb = root.querySelector('[data-kit-summary-expand]');
      if (pb) pb.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    // ── add to cart ───────────────────────────────────
    function addToCart() {
      var cta = root.querySelector('[data-kit-cta]');
      var ctaText = root.querySelector('[data-kit-cta-text]');
      if (!cta || cta.disabled) return;
      var prem = premiumCount();
      var v = variantFor(state.machine, state.set, prem);
      if (!v) return;

      var premiumHandles = [];
      activeGroups().forEach(function (cat) {
        state.picks[cat].forEach(function (h) {
          if (cards[h] && cards[h].dataset.premium === 'true') premiumHandles.push(h);
        });
      });

      var props = {
        _kit_machine: machineDef(state.machine).handle || '',
        _kit_set: state.set,
        _kit_a_picks: state.picks.a.join(','),
        _kit_b_picks: state.picks.b.join(','),
        _kit_c_picks: state.picks.c.join(','),
        _kit_premium: premiumHandles.join(',')
      };
      var ref = activeReferrer();
      if (ref) props._referrer = ref;

      var payload = { id: v.id, quantity: 1, properties: props };
      cta.disabled = true;
      var original = ctaText ? ctaText.textContent : '';
      if (ctaText) ctaText.textContent = 'Adding…';

      var done = function (ok) {
        if (ctaText) ctaText.textContent = ok ? '✓ Added to cart' : 'Try again';
        setTimeout(function () {
          if (ctaText) ctaText.textContent = original || 'Add Kit to Cart';
          render();
        }, 1800);
      };

      if (window.DISCIPLAY && window.DISCIPLAY.cart && window.DISCIPLAY.cart.add) {
        // Open drawer + drop an optimistic line BEFORE awaiting the add, so
        // the side panel feels instant. refreshCart()'s section swap replaces
        // the placeholder with the real (kit-breakdown-aware) line.
        var d = document.querySelector('[data-cart-drawer]');
        if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
        var totalEl = root.querySelector('[data-kit-total]');
        var machineCard = state.machine ? root.querySelector('[data-kit-machine="' + state.machine + '"]') : null;
        var machineImg = machineCard && machineCard.querySelector('img');
        var pickCount = state.picks.a.length + state.picks.b.length + state.picks.c.length;
        var optimisticLine = window.DISCIPLAY.cart.optimisticAdd ? window.DISCIPLAY.cart.optimisticAdd({
          title: 'Build Your Kit',
          variant: machineDef(state.machine).label ? (machineDef(state.machine).label + ' · ' + pickCount + ' picks') : (pickCount + ' picks'),
          image: machineImg ? (machineImg.currentSrc || machineImg.src) : '',
          price: totalEl ? totalEl.textContent.trim() : '',
          quantity: 1
        }) : null;
        window.DISCIPLAY.cart.add(payload).then(function () {
          done(true);
        }).catch(function (err) {
          if (err && err.status && window.DISCIPLAY.cart.rollbackOptimistic) {
            window.DISCIPLAY.cart.rollbackOptimistic(optimisticLine, 1);
          }
          done(false);
        });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () { done(false); });
      }
    }

    // ── events ────────────────────────────────────────
    root.addEventListener('click', function (e) {
      var machineSel = e.target.closest('[data-kit-machine-select]');
      if (machineSel) {
        var mcard = machineSel.closest('[data-kit-machine-card]');
        if (mcard) { setMachine(mcard.dataset.kitMachine); render(); save(); }
        return;
      }
      var selectBtn = e.target.closest('[data-kit-select]');
      if (selectBtn) {
        var card = selectBtn.closest('[data-kit-card]');
        if (card) togglePick(card.dataset.handle);
        return;
      }
      var detailBtn = e.target.closest('[data-kit-detail-open]');
      if (detailBtn) {
        var dcard = detailBtn.closest('[data-kit-card], [data-kit-machine-card]');
        if (dcard) openLightbox(dcard);
        return;
      }
      var headBtn = e.target.closest('[data-kit-step-toggle]');
      if (headBtn) {
        var s = headBtn.closest('[data-kit-step]');
        if (!s) return;
        var name = s.dataset.kitStep;
        if (s.classList.contains('is-open')) {
          // closing the only open step is fine — collapse to none
          s.classList.remove('is-open');
          headBtn.setAttribute('aria-expanded', 'false');
        } else {
          openOnly(name);
        }
        return;
      }
      if (e.target.closest('[data-kit-summary-expand]')) {
        openBreakdown();
        return;
      }
      if (e.target.closest('[data-kit-cta]')) {
        addToCart();
        return;
      }
    });

    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-kit-lightbox-close]')) { closeLightbox(); return; }
        if (e.target.closest('[data-kit-lightbox-add]')) {
          if (lightboxCard) togglePick(lightboxCard.dataset.handle);
        }
      });
    }

    if (breakdown) {
      breakdown.addEventListener('click', function (e) {
        if (e.target.closest('[data-kit-breakdown-close]')) closeBreakdown();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (lightbox && !lightbox.hasAttribute('hidden')) closeLightbox();
      else if (breakdown && !breakdown.hasAttribute('hidden')) closeBreakdown();
    });

    // ── restore from URL + localStorage ──────────────
    function restore() {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = params.has('machine') || params.has('set') ||
                    params.has('picks_a') || params.has('picks_b') || params.has('picks_c');

      // Set from URL takes precedence (landing page passes it here)
      if (params.has('set')) {
        var s = params.get('set');
        if (sets.some(function (x) { return x.value === s; })) state.set = s;
      }

      var src;
      if (fromUrl) {
        src = {
          machine: params.get('machine') || state.machine,
          set: state.set,
          picks: {
            a: (params.get('picks_a') || '').split(',').filter(Boolean),
            b: (params.get('picks_b') || '').split(',').filter(Boolean),
            c: (params.get('picks_c') || '').split(',').filter(Boolean)
          }
        };
      } else {
        var saved = readJSON(KIT_KEY);
        // Only use localStorage if it matches the current Set tier (otherwise
        // picks could spill into hidden groups).
        if (saved && saved.set === state.set) src = saved;
      }

      if (src && machines.some(function (m) { return m.value === src.machine; })) {
        state.machine = src.machine;
      }

      setMachine(state.machine);
      applySetVisibility();

      if (src && src.picks) {
        ['a', 'b', 'c'].forEach(function (cat) {
          if (!isGroupActive(cat)) return;
          (src.picks[cat] || []).forEach(function (h) {
            var c = cards[h];
            if (!c || c.dataset.category !== cat) return;
            if (c.dataset.available !== 'true') return;
            if (state.picks[cat].length >= pickN) return;
            state.picks[cat].push(h);
            cardSelected(c, true);
          });
        });
      }
      applyCardLocks();

      // Open the first incomplete active group (machine lives in the hero,
      // not the accordion).
      var groups = activeGroups();
      var initial = groups[0] || 'a';
      for (var i = 0; i < groups.length; i++) {
        if (state.picks[groups[i]].length < pickN) { initial = groups[i]; break; }
      }
      openOnly(initial);
      render();
    }

    restore();
  }

  function initAll() {
    document.querySelectorAll('[data-kit-builder]').forEach(initKitBuilder);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
